// Logical HTML table grid shared by exports; never inspect docx private fields.
export interface GridCell { element: HTMLTableCellElement; column: number; span: number; rowSpan: number }
export function readTableGrid(table: HTMLTableElement) {
    const occupied: number[] = [];
    const rows: GridCell[][] = [];
    let count = 0;
    for (const [r, row] of Array.from(table.rows).entries()) {
        let column = 0;
        const cells: GridCell[] = [];
        for (const element of Array.from(row.cells)) {
            while ((occupied[column] ?? 0) > r) column++;
            const span = Math.max(1, element.colSpan);
            const rowSpan = Math.min(Math.max(1, element.rowSpan || table.rows.length - r), table.rows.length - r);
            cells.push({ element, column, span, rowSpan });
            for (let c = column; c < column + span; c++) occupied[c] = r + rowSpan;
            column += span;
            count = Math.max(count, column);
        }
        rows.push(cells);
    }
    const widths = Array.from({ length: count }, () => 0);
    Array.from(table.querySelectorAll(':scope > colgroup > col')).forEach((col, i) => {
        if (i < count) widths[i] = parseFloat((col as HTMLElement).style.width) || 0;
    });
    for (const row of rows) for (const cell of row) {
        const sizes = (cell.element.getAttribute('colwidth') ?? '').split(',').map(Number);
        for (let i = 0; i < cell.span; i++) if (!widths[cell.column + i] && sizes[i]! > 0) widths[cell.column + i] = sizes[i]!;
    }
    const valid = widths.filter(w => w > 0);
    const fallback = valid.length ? valid.reduce((a, b) => a + b, 0) / valid.length : 100;
    return { rows, widths: widths.map(w => w > 0 ? w : fallback) };
}
export function fitTableWidths(widths: number[], available: number): number[] {
    const sum = widths.reduce((a, b) => a + b, 0);
    let used = 0;
    return widths.map((w, i) => {
        const size = i === widths.length - 1 ? available - used : Math.max(1, Math.floor(w / sum * available));
        used += size;
        return size;
    });
}
